module.exports = __webpack_public_path__ + "media/fonts/aileron-thin-452eccd7.eot";